(function () {
  'use strict';

  var BAR_SELECTOR = '[class*="essential_annoucement_bar_wrapper"]';
  var root = document.documentElement;
  var observedBars = new Set();
  var resizeObserver = null;
  var updateScheduled = false;
  var stickyHeader = null;
  var stickySpacer = null;
  var stickyHeaderObserver = null;

  function updateStickySpacerHeight() {
    if (!stickyHeader || !stickySpacer) {
      return;
    }

    var height = stickyHeader.classList.contains('fixed-header')
      ? Math.ceil(stickyHeader.getBoundingClientRect().height)
      : 0;
    var nextHeight = height + 'px';

    if (stickySpacer.style.height !== nextHeight) {
      stickySpacer.style.height = nextHeight;
    }
  }

  function updateStickyHeaderTarget() {
    var selector = window.matchMedia('(min-width: 992px)').matches
      ? '#header .header-top'
      : '#header .site-header-mobile';
    var nextHeader = document.querySelector(selector);

    if (!nextHeader || nextHeader === stickyHeader) {
      updateStickySpacerHeight();
      return;
    }

    if (stickyHeaderObserver) {
      stickyHeaderObserver.disconnect();
    }
    if (stickySpacer) {
      stickySpacer.remove();
    }

    stickyHeader = nextHeader;
    stickySpacer = document.createElement('div');
    stickySpacer.className = 'vmax-sticky-header-spacer';
    stickySpacer.setAttribute('aria-hidden', 'true');
    stickyHeader.insertAdjacentElement('afterend', stickySpacer);

    if ('MutationObserver' in window) {
      stickyHeaderObserver = new MutationObserver(updateStickySpacerHeight);
      stickyHeaderObserver.observe(stickyHeader, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    updateStickySpacerHeight();
  }

  function visibleTopLevelBars() {
    return Array.prototype.filter.call(document.querySelectorAll(BAR_SELECTOR), function (bar) {
      var parentBar = bar.parentElement && bar.parentElement.closest(BAR_SELECTOR);
      var style = window.getComputedStyle(bar);
      var rect = bar.getBoundingClientRect();

      return (
        !parentBar &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.height > 0
      );
    });
  }

  function updateAnnouncementHeight() {
    var height = visibleTopLevelBars().reduce(function (total, bar) {
      return total + bar.getBoundingClientRect().height;
    }, 0);

    root.style.setProperty('--vmax-announcement-height', Math.ceil(height) + 'px');
  }

  function observeAnnouncementBars() {
    if (resizeObserver) {
      document.querySelectorAll(BAR_SELECTOR).forEach(function (bar) {
        if (!observedBars.has(bar)) {
          observedBars.add(bar);
          resizeObserver.observe(bar);
        }
      });
    }

    updateAnnouncementHeight();
    updateStickyHeaderTarget();
  }

  function scheduleUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;
    window.requestAnimationFrame(function () {
      updateScheduled = false;
      observeAnnouncementBars();
    });
  }

  function initialize() {
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
    }

    observeAnnouncementBars();
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(scheduleUpdate).observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style'],
        childList: true,
        subtree: true
      });
    }

    window.addEventListener('resize', scheduleUpdate, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
